module.exports = __webpack_public_path__ + "static/blog51-36ccdd76d23b3ed8dce7dc4202a303f7.png";